import React, { useState } from 'react'
import "./Nosotros.css"
import { Contacto } from '../Contacto/Contacto'
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome' 
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

export const Nosotros = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  // Función para manejar la apertura y cierre de cada pregunta
  const handleToggle = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="div-nosotros">
      <img className='img-nosotros' src="/imgs/ropa.jpg" alt="ropa en perchas" />
      <div className="div-texto">
        <h1>Sobre Nosotros</h1>

        <div className="about-section">
          <h2>La forma más fácil de encontrar lo que buscas en segunda mano</h2>

          <p>
            En <strong>eRastro</strong> hemos cambiado las reglas del juego: ya no tienes que perder tiempo 
            navegando en decenas de webs para dar con lo que quieres. Tú nos dices qué buscas 
            y nuestro <strong>sistema de alertas inteligentes</strong> empieza a rastrear webs hasta que lo encuentra por ti.
          </p>

          <p>
            Cuando aparezca ese producto, <strong>te avisamos al instante</strong>. 
            Con eRastro tienes un asistente personal para buscar ropa de segunda mano.
          </p>

          <p>
            <em>Bienvenido a eRastro, la plataforma que busca por ti y te ahorra tiempo de forma más sencilla y sostenible.</em>
          </p>

          <div className="blog-link-section">
            <p>
              Para más información y aprender a usar nuestra herramienta, visita nuestro{' '}
              <Link to="/blog" className="blog-link">Blog</Link>
            </p>
          </div>
        </div>



        {/* Sección de Q&A */}
        <div className="faq-section">
          <h2>Preguntas Frecuentes (Q&A)</h2>

          {/* Pregunta 1 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(0)}>
              ¿Qué es eRastro?
              <span className={`faq-arrow ${activeIndex === 0 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 0 && (
              <div className="faq-answer">
                <p><strong>eRastro es tu buscador personal de segunda mano.</strong> Tú nos dices qué quieres y nuestro sistema de alertas inteligentes rastrea múltiples webs como Vinted, Wallapop o eBay hasta encontrarlo.</p>
                
                <p>No pierdas tiempo buscando: eRastro lo hace por ti y te avisa al instante cuando aparece lo que necesitas.</p>
              </div>

            )}
          </div>

          {/* Pregunta 2 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(1)}>
              ¿En eRastro se pueden comprar productos?
              <span className={`faq-arrow ${activeIndex === 1 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 1 && (
              <div className="faq-answer">
                <p>No, eRastro no vende productos directamente. Recopilamos productos de tiendas de segunda mano para ayudarte a encontrar lo que necesitas de forma rápida y sencilla. Las compras se realizan directamente en las tiendas de segunda mano.</p>
              </div>
            )}
          </div>

          {/* Pregunta 3 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(2)}>
              ¿Cómo funcionan las alertas?
              <span className={`faq-arrow ${activeIndex === 2 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 2 && (
              <div className="faq-answer">
                <p>Las alertas son muy fáciles de utilizar. Solo tienes que indicar qué buscas: marca, modelo, talla, tipo de producto o cualquier detalle que te interese.</p>
                <p>Nuestro sistema buscará constantemente en las webs de segunda mano y te <strong>notificará</strong> cuando encuentre productos que encajan con tus criterios.</p>
              </div>
            )}
          </div>

          {/* Pregunta 4 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(3)}>
              ¿Cómo puedo gestionar mi suscripción?
              <span className={`faq-arrow ${activeIndex === 3 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 3 && (
              <div className="faq-answer">
                <p>Puedes suscribirte a cualquiera de nuestros planes y cambiar entre ellos cuando desees. Si decides cancelar, tu suscripción permanecerá activa hasta el final del periodo ya pagado, pero no se renovará.</p>
              </div>
            )}
          </div>

          {/* Pregunta 5 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(4)}>
              ¿Qué pasa si borro mi cuenta?
              <span className={`faq-arrow ${activeIndex === 4 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 4 && (
              <div className="faq-answer">
                <p>Al borrar tu cuenta, se eliminará tu usuario y se cancelarán automáticamente todas las suscripciones activas. Ten en cuenta que esta acción es irreversible.</p>
              </div>
            )}
          </div>
          {/* Pregunta 6 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(5)}>
              ¿Cómo funciona el rastreador de productos?
              <span className={`faq-arrow ${activeIndex === 5 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 5 && (
              <div className="faq-answer">
                <p>Selecciona los productos que te interesan y agrégalos al Rastreador de productos. A partir de ese momento, nuestro sistema los monitorea automáticamente todos los días para detectar cualquier cambio de precio.</p>
                
                <p>Cuando se detecta una bajada, te enviamos una notificación inmediata para que aproveches la oportunidad y compres al mejor precio posible. Así, nunca se te escapará una buena oferta.</p>
              </div>

            )}
          </div>
          {/* Pregunta 7 */}
          <div className="faq-item">
            <button className="faq-question" onClick={() => handleToggle(6)}>
              ¿Puedo utilizar eRastro si no resido en España?
              <span className={`faq-arrow ${activeIndex === 6 ? 'open' : ''}`}><FontAwesomeIcon icon={faChevronDown} /></span>
            </button>
            {activeIndex === 6 && (
              <div className="faq-answer">
                <p>No, eRastro ha sido creado para buscar productos solo en España.</p>
              </div>
            )}
          </div>
        </div>
        <div>
          <Contacto />
        </div>
        <div className='paginas-legales'>
          <Link to="/aviso-legal">Aviso legal</Link>
          <Link to="/politica-cookies">Política de Cookies</Link>
          <Link to="/politica-privacidad">Política de Privacidad</Link>
        </div>
      </div>
    </div>
  )
}
